import { useMutation } from "react-query";

import {
  AI_BUTTON_ANIMATION_COUNT_KEY,
  setLocalStorageItem,
} from "../../helpers/localStorage";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const setAIButtonAnimationCount = (options: APQueryOptions = {}) => {
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();
  const invalidateList = [["ai-button-animation-count"]];

  return useMutation({
    mutationFn: (count: number) => {
      setLocalStorageItem(AI_BUTTON_ANIMATION_COUNT_KEY, count);
      return Promise.resolve(true);
    },
    onError: defaultOnMutateError(options),
    onSettled: () => defaultOnMutateSettled(invalidateList),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
